module.exports = __webpack_public_path__ + "Icono_Advertencia_512px.png";